import styled from 'styled-components';
export var StyledTableBody = /*#__PURE__*/styled.tbody.withConfig({
  displayName: "StyledTableBody",
  componentId: "c11n-8-111-1__sc-f04mzl-0"
})([""]);